var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTranslate = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.594 6.053a.75.75 0 0 0 1.06 0 4.25 4.25 0 0 1 6.007 0l.138.138h-1.118a.65.65 0 1 0 0 1.3h2.827a.65.65 0 0 0 .65-.65V4.014a.65.65 0 1 0-1.3 0v1.114l-.136-.136a5.75 5.75 0 0 0-8.128 0 .75.75 0 0 0 0 1.061m-.19 3.856a.75.75 0 0 0-1.5 0v1.25H2.689a.75.75 0 0 0 0 1.5h.915a9.4 9.4 0 0 0 1.938 3.263 7.9 7.9 0 0 1-2.585 1.262.75.75 0 0 0 .401 1.446 9.4 9.4 0 0 0 3.298-1.672 9.4 9.4 0 0 0 3.298 1.672.75.75 0 1 0 .4-1.446 7.9 7.9 0 0 1-2.584-1.262 9.4 9.4 0 0 0 1.937-3.264h.947a.75.75 0 0 0 0-1.5H7.405zm-.75 5.008a7.9 7.9 0 0 0 1.448-2.259H5.208a7.9 7.9 0 0 0 1.447 2.259m10.285.45 1.165-3.108 1.166 3.109zm-1.8.53-.735 1.958a.75.75 0 1 0 1.404.527l.568-1.514h3.457l.568 1.514a.75.75 0 0 0 1.404-.527l-.702-1.873a.8.8 0 0 0-.093-.248l-1.736-4.626v-.001a1.25 1.25 0 0 0-2.34 0l-1.765 4.706a1 1 0 0 0-.03.083",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranslate);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };